<template lang="html">
  <div class="commentP">
    <div class="commentProductItem" @click="toLookEvaluate">
      <div v-if="item.essence == 1" class="jxpjTag"></div>
      <!-- <div class="userInfo">
        <div class="avatar">
          <img :src="item.user.photo" alt="" />
        </div>
        <div class="userDes">
          <div class="userDesT">
            <div>
              <span class="userName">{{ name(item.user.nickname) }}</span>
            </div>
            <span class="commentTime">{{ dateTransformer(item.created_at) }}</span>
          </div>
          <star :score="item.score * 2" />
        </div>
      </div> -->

      <div class="title">
        <img class="avatar" width="52px" height="52px" :src="item.user.photo ? item.user.photo : defaultAvatar" alt="" />
        <div class="left">
          <div class="name">
            {{ name(item.user.nickname) }}
          </div>
          <div class="rate">
            <img v-for="i in starCount.redStar" :key="i + Math.random()" src="../../assets/image/sx_icon_star_yellow@3x.png" />
            <img v-for="i in starCount.halfStar" :key="i + Math.random()" src="../../assets/image/sx_icon_star_grey@3x.png" />
            <img v-for="i in starCount.greyStar" :key="i + Math.random()" src="../../assets/image/sx_icon_star_grey@3x.png" />
          </div>
        </div>
        <div class="time">
          <!-- {{ dateTransformer(item.created_at) }} -->
        </div>
      </div>

      <p v-if="item.silkBannerNum > 0" class="sendYuesaoTag">赠送月嫂{{ item.silkBannerNum }}面锦旗<i class="moreIcon" /></p>
      <p v-else-if="item.user.uid === cookieUid" class="myCommentTag">
        我的评价
      </p>
      <div v-if="item.content" class="commentContent" :class="{ ommitContent: ommitContent }">
        {{ item.content }}
      </div>
      <div v-if="item.image_urls && item.image_urls.length > 0" class="commentImgs">
        <ul>
          <li v-for="(image, index) in item.image_urls" :key="index">
            <!-- <img v-if="item.image_urls.length == 1" :src="image" alt="" class="imgOne" />
            <img v-else-if="item.image_urls.length == 4" :src="image" alt="" class="imgFour" />
            <img v-else :src="image" alt="" class="imgLi" /> -->
            <ImgHzw width="200" height="200" :tailor="true" :src="image" class="imgLi" />
          </li>
        </ul>
      </div>
      <div class="serviceTag">
        <span class="serviceType">服务类型：{{ item.category ? item.category : '育儿顾问服务' }}</span>
      </div>
      <div v-if="showReply && item && item.replies && item.replies[0]" class="replay">
        <p class="title">商家回复:</p>
        <div>{{ item.replies[0].content }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { toCzj, uid } from '@utils/index'
import { toV } from '@/app/core/utils'

import defaultAvatar from '../../assets/image/avatar_comment@3x.png'

export default {
  name: 'CommentItem',
  components: {
  },
  props: {
    item: {
      type: Object,
      default() {
        return {}
      }
    },
    // 评论文案是否要控制行数
    ommitContent: {
      type: Boolean,
      default: true
    },
    // 是否显示回复
    showReply: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      defaultAvatar,
      limitReply: {
        isLong: false,
        isShow: false,
        isActive: false
      },
      cookieUid: uid
    }
  },
  computed: {
    starCount() {
      const _t = {}
      //有 ".5"
      if (this.item.score % 1 > 0) {
        _t.redStar = parseInt(this.item.score)
        _t.halfStar = 1
        _t.greyStar = 5 - parseInt(this.item.score)
      } else {
        _t.redStar = parseInt(this.item.score)
        _t.halfStar = 0
        _t.greyStar = 5 - parseInt(this.item.score)
      }
      return _t
    }
  },
  // created() {},
  methods: {
    toLookEvaluate() {
      // 新查看评价入口
      // this.$$loading(true)
      window.scrollTo(0, 0)
      // 育儿的评论详情跳转逻辑不动，成长加的评论详情跳转到成长加
      if (this.$store.state.shopHome && this.$store.state.shopHome.shopYuer) {
        toV({
          name: 'evaluate',
          query: {
            commentId: this.item.id,
            ht: 'look'
          }
        })
      } else {
        toCzj(`https://m.czj100.com/look/${this.item.id}`)
      }
    },
    name(val) {
      if (val.length > 1) {
        return `${val.charAt(0)}***${val.charAt(val.length - 1)}`
      } else {
        return `${val.charAt(0)}***`
      }
    }
  }
}
</script>

<style lang="scss" scoped>
// .commentP {
//   &:last-child {
//     .commentProductItem {
//       &::after {
//         border: 0;
//       }
//     }
//   }
// }

.jxpjTag {
  // background: url('../src/app/pages/shop/assets/image/icon-jxpj.png') no-repeat
  //   center center;
  background-size: (90px) (90px);
  width: (90px);
  height: (90px);
  position: absolute;
  right: 0;
  top: (75px);
  z-index: 10;
}

.commentProductItem {
  background: #fff;
  padding: (32px) 0 (32px);
  // @include border(bottom);
  border-bottom: 1px solid #eee;
  position: relative;
  .title {
    overflow: hidden;
    margin-bottom: 12px;
    .avatar {
      width: 52px;
      height: 52px;
      border-radius: 50%;
      float: left;
    }
    .left {
      margin-left: 8px;
      float: left;
      .name {
        font-size: 26px;
        color: #262626;
        line-height: 32px;
      }
      .rate {
        font-size: 26px;
        color: #262626;
        line-height: 32px;
        img {
          width: 16px;
          height: 16px;
          margin-right: 4px;
        }
      }
    }

    .time {
      font-size: 24px;
      color: #999999;
      text-align: right;
      line-height: 30px;
    }
  }
  .userInfo {
    display: flex;
    margin-bottom: (20px);

    .avatar {
      width: (64px);
      height: (64px);
      @include border(all, #f0f0f0, 1Px, 50%);
      border-radius: 50%;
      margin-right: (12px);
      & > img {
        width: (64px);
        height: (64px);
        border-radius: 50%;
      }
    }
    .userDes {
      flex: 1;
      .userDesT {
        display: flex;
        justify-content: space-between;
        align-content: center;
        .userName {
          font-size: (28px);
          color: #262626;
          line-height: (34px);
          font-weight: 500;
          margin-right: (12px);
        }
        .userLevel {
          font-size: (18px);
          color: #f9f9f7;
          text-align: center;
          line-height: (20px);
          background-image: linear-gradient(90deg, #ff397e 0%, #ff074c 100%);
          border-radius: (14px);
          padding: 0 (12px);
        }
        .userLevelPlus {
          font-size: (18px);
          color: #f4efdb;
          text-align: center;
          line-height: (18px);
          background: #121212;
          border-radius: (14px);
          padding: 0 (12px);
        }
        .commentTime {
          font-size: (22px);
          color: #999999;
          line-height: (28px);
        }
      }
    }
  }

  .myCommentTag {
    font-size: (24px);
    color: #ff5900;
    line-height: (30px);
    margin-bottom: (12px);
  }

  .sendYuesaoTag {
    display: flex;
    align-items: center;
    font-size: (24px);
    color: #ff5900;
    line-height: (30px);
    margin-top: 8px;
    margin-bottom: (12px);
    .moreIcon {
      margin-left: (4px);
      // margin-top: (2px);
      width: (20px);
      height: (20px);
      background: url('../../assets/image/icon_more_yellow.png') no-repeat center center;
      background-size: 100% 100%;
    }
    // &>i {
    //     line-height: (30px);
    //     border: solid #FF397E;
    //     border-width: 0 1px 1px 0;
    //     display: inline-block;
    //     width:6px;
    //     height:6px;
    // }
    // .rightArr {
    //     transform: rotate(-45deg);
    //     -webkit-transform: rotate(-45deg);
    // }
  }

  .commentContent {
    font-size: (26px);
    color: #262626;
    line-height: (38px);
    margin-bottom: (20px);
  }
  .ommitContent {
    display: -webkit-box;
    word-break: break-all;
    text-align: left;
    -webkit-line-clamp: 5;
    -webkit-box-orient: vertical;
    text-overflow: ellipsis;
    max-height: (210px);
    overflow: hidden;
  }
  .commentImgs {
    // margin-bottom: (20px);

    & > ul {
      display: flex;
      overflow-x: auto;
      overflow-y: hidden;
      flex-wrap: nowrap;
      &::-webkit-scrollbar {
        display: none;
      }
      & > li {
        flex-shrink: 0;
        width: (200px);
        height: (200px);
        margin-right: (18px);
        margin-bottom: (20px);
      }

      // & > li:nth-child(3n) {
      //   .imgLi {
      //     margin-right: 0;
      //   }
      // }
    }
    .imgLi {
      border-radius: 8px;
      overflow: hidden;
    }

    .imgOne {
      width: (446px);
      height: (446px);
      border-radius: (8px);
      margin-bottom: (18px);
    }

    .imgFour {
      width: (214px);
      height: (214px);
      margin-right: (18px);
      margin-bottom: (18px);
      border-radius: (8px);
    }
  }
  .serviceTag {
    font-size: (22px);
    color: #999999;
    line-height: (28px);
    .serviceType {
      margin-right: (36px);
    }
  }

  .replay {
    background: #f9f9f9;
    border-radius: (16px);
    font-size: (26px);
    color: #808080;
    line-height: (38px);
    padding: (24px) (20px);
    margin-bottom: (18px);
    .title {
      font-size: (26px);
      color: #262626;
      line-height: (34px);
      font-weight: 500;
      margin-bottom: (8px);
    }
  }
}
</style>
